const C_LOC_COOKIE = "C_LOC";
const C_LOC_COOKIE_EXPIRES_DAYS = 365;
const C_2LOC_COOKIE = "C_2LOC";
const C_2LOC_COOKIE_EXPIRES_DAYS = 365;
const C_WHLOC_COOKIE = "C_WHLOC";
const C_WHLOC_COOKIE_EXPIRES_DAYS = 180;
const SelectedLanguage = "selectedLanguage";
const SelectedLanguageMaxAge = 86400;
export {
  C_2LOC_COOKIE,
  C_2LOC_COOKIE_EXPIRES_DAYS,
  C_LOC_COOKIE,
  C_LOC_COOKIE_EXPIRES_DAYS,
  C_WHLOC_COOKIE,
  C_WHLOC_COOKIE_EXPIRES_DAYS,
  SelectedLanguage,
  SelectedLanguageMaxAge
};
